import { BaseModel } from '@/api/base-model'
import { Offer } from '@/api/model/offer'
import { ProductType } from '@/api/types'
import { ProductAPI } from '@/api/backend-client'

export class Product extends BaseModel<Product> {
    protected collectionName = ProductAPI.collectionName

    constructor(
        public offer: Offer,
        public id: string,
        public name: string,
        public description: string,
        public price: number,
        public type: ProductType,
        public optional: boolean,
        public widgetFlowType: string,
        public included: boolean = false,
    ) { super(id) }

    static fromData(data: any): Product {
        if (data === null || typeof data === 'string' || data instanceof Product) {
            return data
        }

        return new Product(
            data.offer ? Offer.fromData(data.offer) : null,
            data.id,
            data.name,
            data.description,
            data.price,
            data.type,
            data.optional,
            data.widgetFlowType,
            !data.optional,
        )
    }
}
